import React from "react";

export default function NewConstructionForSale() {
  return <div>NewConstructionForSale</div>;
}
